import SubCategoriesService1 from './SubCategoriesService1';

export {default} from './SubCategoriesService1';
export const subCategoriesService1 = new SubCategoriesService1();